<template>
  <div class="ls-pill" :class="backgroundClass">
    <span class="ls-pill--label">{{ label }}</span>
  </div>
</template>

<script>
import VueTypes from 'vue-types';
import _ from 'lodash';
import { lsColors } from '@/constants';
import { themedComponentMixin } from '@/mixins';

export default {
  name: 'LsPill',
  mixins: [themedComponentMixin],
  props: {
    label: VueTypes.string.isRequired,
    bgColor: VueTypes.oneOf([..._.keys(lsColors), ...['blue', 'beige']]).def('primary-light'),
  },
  computed: {
    backgroundClass() {
      if (this.themedClass.length) {
        return [...this.themedClass, `pill-bg-${this.bgColor}`];
      }

      const specialColors = {
        blue: 'ls-pill--color-blue',
        beige: 'ls-pill--color-beige',
      };

      return specialColors[this.bgColor]
        ? specialColors[this.bgColor]
        : `has-background-${this.bgColor}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.ls-pill {
  display: inline-flex;
  padding: 1px 12px;
  border-radius: 28px;

  &.themed-component {
    .ls-pill--label {
      color: $theme-color-gray-darker;
      font-size: var(--theme-txt-body-sm);
    }

    &.pill-bg {
      &-blue {
        background-color: $theme-color-info-light;
      }
      &-beige {
        background-color: $theme-color-warning-light;
      }
      &-primary-light {
        background-color: $theme-color-primary-light;
      }
    }
  }
}

.ls-pill--label {
  color: $grey-darker;
  font-family: Montserrat;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 22px;
  text-align: center;
}

.ls-pill--color-beige {
  background-color: #ffe0b2;
}

.ls-pill--color-blue {
  background-color: #c8ddf6;
}
</style>
